import App from "@/views/App.vue";

export default [
  {
    path: "/exclusive-club",
    name: "exclusiveClub",
    component: App,
    redirect: { name: "exclusiveClubHome" },
    children: [
      {
        path: "",
        name: "exclusiveClubHome",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/ExclusiveClub.vue"),
        meta: {
          displayName: "displayName.exclusiveClub",
          requiresAuth: true,
        },
      },
      {
        path: "/exclusive-club/sobre",
        name: "exclusiveClubAbout",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/AboutExclusiveClub.vue"
          ),
        meta: {
          displayName: "displayName.aboutExclusiveClub",
          requiresAuth: true,
        },
      },
      {
        path: "/exclusive-club/beneficio/:id",
        name: "exclusiveClubProduct",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/Product.vue"),
        meta: {
          displayName: "displayName.product",
          requiresAuth: true,
        },
      },
      {
        path: "/novo-beneficio",
        name: "newProduct",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/NewProduct.vue"),
        meta: {
          displayName: "displayName.newProduct",
          requiresAuth: true,
        },
      },
      {
        path: "/editar-beneficio/:id",
        name: "editProduct",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/EditProduct.vue"),
        meta: {
          displayName: "displayName.editProduct",
          requiresAuth: true,
        },
      },
      {
        path: "/preview-beneficio/:id",
        name: "viewProduct",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/DetailsProduct.vue"),
        meta: {
          displayName: "displayName.viewProduct",
          requiresAuth: true,
        },
      },
    ],
  },
];
